import colors from './colors';
import images from './images';
import copy from './copy';

/** 自用蓝 — Figma「收银台 (自用主题)」 */
export default {
  id: 'self-blue',
  name: 'Self Blue',
  code: 'PJcYwEbN',

  colors,
  copy,

  gradients: {
    card: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%)`,
    header: `linear-gradient(180deg, ${colors.white} 0%, ${colors.white} 100%)`,
    btnPrimary: `linear-gradient(180deg, ${colors.btnGradientStart} 2.174%, ${colors.btnGradientEnd} 100%)`,
    btnStrong: `linear-gradient(180deg, ${colors.btnStrongGradientStart} 0%, ${colors.btnStrongGradientEnd2} 100%)`,
    copyBtn: `linear-gradient(180deg, ${colors.primaryLight} 2.174%, ${colors.primaryDeep} 100%)`,
  },

  images,
};
